module.exports = __webpack_public_path__ + "img/payment.98b001a9.svg";